import * as React from 'react';
import { Close16 } from '@cian/ui-kit/icons';

import * as styles from './CloseButton.css';

type TButtonProps = Omit<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  'type' | 'className'
>;

export const CloseButton: React.FC<TButtonProps> = props => {
  return (
    <button {...props} className={styles['button']} type="button">
      <Close16 />
    </button>
  );
};

CloseButton.displayName = 'CloseButton';
